"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * iPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.15.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookApi = exports.BookApiFactory = exports.BookApiFp = exports.BookApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * BookApi - axios parameter creator
 * @export
 */
exports.BookApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Book\"]
         * @summary Get all books | Permission required: [\"readAll\", \"Book\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBooks: (filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/book/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *  **Permission required**: [\"readOne\", \"Book\"]
         * @summary Get book by id | Permission required: [\"readOne\", \"Book\"]
         * @param {string} bookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookById: (bookId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bookId' is not null or undefined
            common_1.assertParamExists('getBookById', 'bookId', bookId);
            const localVarPath = `/book/{bookId}/`
                .replace(`{${"bookId"}}`, encodeURIComponent(String(bookId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BookApi - functional programming interface
 * @export
 */
exports.BookApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BookApiAxiosParamCreator(configuration);
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Book\"]
         * @summary Get all books | Permission required: [\"readAll\", \"Book\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBooks(filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllBooks(filter, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *  **Permission required**: [\"readOne\", \"Book\"]
         * @summary Get book by id | Permission required: [\"readOne\", \"Book\"]
         * @param {string} bookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookById(bookId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBookById(bookId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BookApi - factory interface
 * @export
 */
exports.BookApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BookApiFp(configuration);
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Book\"]
         * @summary Get all books | Permission required: [\"readAll\", \"Book\"]
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBooks(filter, options) {
            return localVarFp.getAllBooks(filter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"Book\"]
         * @summary Get book by id | Permission required: [\"readOne\", \"Book\"]
         * @param {string} bookId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookById(bookId, options) {
            return localVarFp.getBookById(bookId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BookApi - object-oriented interface
 * @export
 * @class BookApi
 * @extends {BaseAPI}
 */
class BookApi extends base_1.BaseAPI {
    /**
     *  **Permission required**: [\"readAll\", \"Book\"]
     * @summary Get all books | Permission required: [\"readAll\", \"Book\"]
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookApi
     */
    getAllBooks(filter, options) {
        return exports.BookApiFp(this.configuration).getAllBooks(filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *  **Permission required**: [\"readOne\", \"Book\"]
     * @summary Get book by id | Permission required: [\"readOne\", \"Book\"]
     * @param {string} bookId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookApi
     */
    getBookById(bookId, options) {
        return exports.BookApiFp(this.configuration).getBookById(bookId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BookApi = BookApi;
